import { api, fetchWithAuth } from './api';

export interface FunnelInsightStage {
  stage: string;
  label: string;
  count: number;
  pct_of_supply: number;
  drop_off_from_prev: number | null;
}

export interface FunnelInsightFacts {
  pct_unprotected_google_ads: number | null;
  avg_paid_share_qualified: number | null;
  pct_failing_economics_gate: number | null;
  gate_threshold_paid_share: number;
  site_kind_breakdown: Record<string, number>;
}

export interface FunnelInsightSummary {
  total_supply: number;
  stages: FunnelInsightStage[];
  facts: FunnelInsightFacts;
  generated_at: string;
}

export const leadInsightsApi = {
  getSummary: (country?: string) => {
    const qs = country ? `?country=${encodeURIComponent(country)}` : '';
    return api.get<FunnelInsightSummary>(`/lead-insights/summary${qs}`);
  },

  downloadExportCsv: async (country?: string): Promise<void> => {
    const qs = country ? `?country=${encodeURIComponent(country)}` : '';
    const res = await fetchWithAuth(`/api/lead-insights/export.csv${qs}`);
    if (!res.ok) throw new Error(`Export fehlgeschlagen (${res.status})`);
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'lead-funnel-export.csv';
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  },
};
